import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { message, Modal } from 'antd-v5';
import { getRequest } from '../../../../core/apiRequests';
// import DropdownSelect from '../../DropdownSelect';
import { setMsgClient, getClientChat, setInboxList, setStoreInboxList } from '../../../../reducers/messaging';
import { deleteClient, mergeClient, mergeTwoClients } from '../../../../services/clients';
import AddClientModal from '../../../../componentsV2/Layout/AddClientModal';
import SearchClientsInputV2 from '../../../../componentsV2/CustomizedAntDesign/SearchClientsInputV2';

const uuidv4 = require('uuid/v4');

const NoNumberBanner = ({
  messagingClient,
  merchantId,
  inboxList,
  storeInboxList,
  auth,
  clearSelectedClient,
  messagingMobile,
  mergeSelectedClient,
}) => {
  const [openDelete, setOpenDelete] = useState(false);
  const [openMerge, setOpenMerge] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [client, setClient] = useState({});
  const [modal, contextHolder] = Modal.useModal();
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const confirmDelete = async () => {
    setLoading(true);
    await deleteClient({ clientId: messagingClient.client_id, loadingStatusOff: true });
    message.success('Client Removed');
    setLoading(false);
    setOpenDelete(false);
    clearSelectedClient();
    history.push('/Messaging/inbox');
  };

  const getClientData = () => {
    if (merchantId) {
      (async () => {
        const reqObj = {
          params: ['clients', merchantId, 0, 'clientPreferences'],
        };
        const prefData = await getRequest(reqObj);
        if (prefData.length > 0) {
          const dataObj = prefData[0];
          const { preferenceData, lifeEventData } = dataObj;
          const prefObj = {};
          preferenceData.forEach(prf => {
            prefObj[prf.config_id] = prf;
          });
          const leObj = {};
          lifeEventData.forEach(le => {
            let date = '';

            if (le.date) {
              const d = moment(le.date.padStart(8, '2020'), 'YYYYMMDD');
              if (d.isValid()) date = le.date;
            }

            leObj[le.type] = {
              ...le,
              date,
              life_event_type_id: le.life_event_type_id ? le.life_event_type_id : '',
            };
          });

          const newClientAddress = [
            {
              address_1: '',
              address_2: '',
              city: '',
              client_id: null,
              id: null,
              postal_code: '',
              state: '',
              type: '',
            },
          ];
          const addObj = {};
          newClientAddress.forEach(addr => {
            addObj[uuidv4()] = addr;
          });
        } else {
          console.log('error getting client data');
        }
      })();
    }
  };

  useEffect(() => {
    (async () => {
      getClientData();
    })();
  }, [merchantId]);

  const handleNewSuccess = data => {
    if (data && data.id) {
      const newStoreInboxList = storeInboxList.map(listItem => {
        if (listItem.id === messagingClient.chat_id) {
          return {
            ...listItem,
            name: data.name,
            client: {
              ...listItem.client,
              name: data.name,
            },
          };
        }

        return listItem;
      });

      const newInboxList = inboxList.map(listItem => {
        if (listItem.id === messagingClient.chat_id) {
          return {
            ...listItem,
            name: data.name,
            client: {
              ...listItem.client,
              name: data.name,
            },
          };
        }

        return listItem;
      });

      setMsgClient({ ...messagingClient, name: data.name, anonymous: false });
      setStoreInboxList(newStoreInboxList);
      setInboxList(newInboxList);
      setOpenNew(false);
    }
  };

  async function handleMergeClient(primaryClientId, secondaryClientId) {
    const data = {
      primaryClientId,
      secondaryClientId,
      storeId: auth.selectedStore,
    };
    try {
      const resp = await mergeTwoClients({ data, loadingStatusOff: true });
      const newChatId = resp?.chats?.filter(chat => chat.store_id === auth.selectedStore)[0]?.id;
      const newStoreInboxList = storeInboxList.filter(item => item.id !== messagingClient.chat_id);
      setStoreInboxList(newStoreInboxList);
      message.success('Client Merged Successfully');
      getClientChat({ client_id: primaryClientId });
      //mergeSelectedClient();
      setMsgClient({ ...messagingClient, chat_id: newChatId || null, name: client.name });
    } catch (error) {
      console.error(error);
      message.error('Error merging clients');
    }
  }

  return (
    <div>
      <div className="opted-out-banner flex-row-center-center">
        <p>We don&apos;t recognize this number</p>
      </div>
      <div className="unknown-number-banner flex-row-spacearound-nowrap">
        <button
          type="button"
          className="transparentButton border-none transparent"
          onClick={() => setOpenNew(!openNew)}
        >
          New Client
        </button>
        <button
          type="button"
          className="transparentButton border-none transparent"
          onClick={() => setOpenMerge(!openMerge)}
        >
          Merge
        </button>
        <button type="button" onClick={() => setOpenDelete(!openDelete)} className="red border-none transparent fw-600">
          Delete
        </button>
      </div>
      {contextHolder}
      <Modal
        open={openDelete}
        title="Delete Client"
        okText="Delete"
        confirmLoading={loading}
        onOk={confirmDelete}
        onCancel={() => setOpenDelete(false)}
        okButtonProps={{ loading, danger: true }}
        cancelButtonProps={{ disabled: loading }}
        width={350}
        destroyOnClose
      >
        Are you sure you want to delete this client? <br />
        This action cannot be undone
      </Modal>
      <AddClientModal
        open={openNew}
        setOpen={setOpenNew}
        onSuccess={data => handleNewSuccess(data)}
        hiddenFields={{
          mobile: true,
          email: true,
          preferredContactType: true,
          storeId: true,
        }}
        initialValues={{
          name: '',
          mobile: messagingMobile,
          email: '',
          preferredContactType: 'SMS',
          storeId: auth.storeId,
        }}
        mergeClientId={messagingClient.client_id}
      />
      <Modal
        title="Merge Clients"
        width={456}
        open={openMerge}
        onCancel={() => {
          setOpenMerge(false);
          setClient({});
        }}
        onClose={() => {
          setOpenMerge(false);
          setClient({});
        }}
        onOk={() => {
          modal.confirm({
            title: 'Merge clients',
            okText: 'Merge client',
            icon: <ExclamationCircleOutlined />,
            width: 440,
            cancelText: 'Cancel',
            centered: true,
            async onOk() {
              return handleMergeClient(client.id, messagingClient.client_id);
            },
            onCancel() {
              setClient({});
            },
            content: (
              <div className="flex-col-start gap-24 m-btm-24">
                <span className="fs-14" style={{ opacity: 0.65 }}>
                  Do you want to merge this conversation with {client.name} and update their mobile number to{' '}
                  {messagingClient.name}?
                </span>
                <span className="fs-14" style={{ opacity: 0.65 }}>
                  This action cannot be undone
                </span>
              </div>
            ),
          });
        }}
      >
        <SearchClientsInputV2 onSelect={client => setClient(client)} />
      </Modal>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(NoNumberBanner);
